import React from 'react'
import {UserAction} from "../../../redux/reducers/user";
import {useDispatch} from "react-redux";
import {ButtonPrimary} from "../../button";
import {EAlert} from "../../../enums";
import {AlertBig, AlertBigInfoText} from "../../alert/AlertBig";

export const CompleteAndSignIn = ({title, description, buttonText, signinData}) => {
    const dispatch = useDispatch();

    const onContinue = (e) => {
        console.log('onContinue', signinData);
        dispatch(UserAction.signIn(signinData))
            .then((data) => {
                console.log('successResponse', data);
            }, (error) => {
                console.log('Error response', error);
            });
    }
    return (
        <>
            <div className="w-full mb-6">
                <AlertBig
                  type={EAlert.success}
                  title={title}
                >
                    <AlertBigInfoText>{description}</AlertBigInfoText>
                </AlertBig>

                <ButtonPrimary
                    className={'w-full mt-6'}
                    onClick={onContinue}
                >
                    {buttonText}
                </ButtonPrimary>
            </div>
        </>
    )
}

export default CompleteAndSignIn
